import { Pipe, PipeTransform } from '@angular/core';
import { LookupItemDto } from '@core/api';

@Pipe({
  name: 'lookupOptions',
  pure: true,
})
export class LookupOptionsPipe implements PipeTransform {
  transform(options: LookupItemDto[], lang: string): { id: number; title: string }[] {
    if (!Array.isArray(options)) {
      return [];
    }

    return options.map(opt => ({
      id: opt.id,
      title:
        lang === 'pl'
          ? (opt.additionalData?.['Title'] ?? opt.additionalData?.['TitleEN'])
          : (opt.additionalData?.['TitleEN'] ?? opt.additionalData?.['Title']),
    }));
  }
}
